import {schema} from 'normalizr';
import schemaAttributeLevels from "../attributeLevels/schema";

export default new schema.Entity('attributes', {
  levels: [schemaAttributeLevels],
});